<template>
  <div class="view-tools-coproducer">
    <page-header
      title="Coproduções"
      subtitle="Compartilhe o produto com seus coprodutores."
    />
    <page-container>
      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <bp-select
          slim
          select
          id="product-select"
          class="pt-5"
          v-model="product_id"
          placeholder="Selecionar produto..."
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </action-dispatcher>
      <div v-if="product_id" class="pt-5">
        <div class="view-product-coproducers">
          <bp-table-header :total="pagination.count" @refresh="refresh">
            <template #buttons>
              <bp-button
                size="md"
                icon="fa-light fa-plus"
                label="Cadastrar coprodutor"
                @click="addCoproducer"
              />
            </template>
          </bp-table-header>

          <bp-data-table
            class="my-7"
            :loading="loading"
            :columns="columns"
            :data="coproducers"
          />

          <bp-paginator
            v-if="!loading"
            v-model="page"
            :pagination="pagination"
            @change-page="dispatch"
          />

          <responsive-modal
            v-model="modal"
            size="lg"
            title="Cadastrar coprodutor"
          >
            <coproducer-modal
              :productId="product.id"
              @refresh="refresh"
              @close="modal = false"
            />
          </responsive-modal>
        </div>
      </div>
    </page-container>
  </div>
</template>
<script>
import CoproducerModal from "@/components/product/coproducer/CoproducerModal.vue";
import { formatDate, formatPercentage } from "@/functions/formatting";
import CoProducersMixin from "@/mixins/coproducers.js";
import EditProductMixin from "@/mixins/editProduct.js";
import { mapState } from "vuex";

export default {
  mixins: [CoProducersMixin, EditProductMixin],
  components: { CoproducerModal },
  data() {
    return {
      product_id: null,
      page: 1,
      modal: false,
      loading: false,
      columns: [
        {
          name: "E-mail",
          field: "co_producer",
          transform: v => v.email
        },
        {
          name: "Comissão",
          field: "tax",
          transform: formatPercentage,
          size: "0.7fr"
        },
        {
          name: "Validade do contrato",
          field: "contract_time",
          transform: formatDate,
          size: "0.7fr"
        },
        {
          name: "Status",
          field: "status",
          transform: this.formatStatus,
          class: this.formatStatusBadge,
          size: "0.7fr"
        },
        {
          name: "",
          type: "menu",
          disabled: ({ status }) => status !== "active",
          options: v => [
            {
              label: "Desativar",
              color: "negative",
              icon: "fa-light fa-power-off",
              click: this.deactivateCoproducer,
              dialog: {
                text: `Deseja mesmo desativar a coprodução com ${v.co_producer.email}?`,
                variant: "negative",
                icon: "fa fa-hexagon-exclamation",
                secondaryAction: this.deactivateCoproducer,
                buttonText: "Cancelar",
                secondaryButtonText: "Confirmar"
              }
            }
          ]
        }
      ]
    };
  },
  watch: {
    product_id(product_id) {
      if (product_id) {
        this.dispatch(product_id);
        this.$store.commit(
          "product/setProduct",
          this.products.find(p => p.id === product_id)
        );
      }
    }
  },

  methods: {
    formatStatus(status) {
      const statusMap = {
        active: "Ativo",
        cancelled: "Inativo",
        rejected: "Rejeitado",
        waiting_validation: "Aguardando Aprovação",
        pendent: "Pendente"
      };

      return statusMap[status];
    },
    formatStatusBadge(status) {
      const statusMap = {
        active: "active-badge",
        cancelled: "inactive-badge",
        rejected: "inactive-badge",
        waiting_validation: "draft-badge",
        pendent: "draft-badge"
      };

      return statusMap[status];
    },

    addCoproducer() {
      this.modal = true;
    },
    deactivateCoproducer(coproducer) {
      this.$store
        .dispatch("user/putCoProducerProduct", {
          id: coproducer.id,
          status: "cancelled"
        })
        .then(() => {
          this.$message.success("Coprodução desativada");
          this.refresh();
        })
        .catch(() => this.$message.error("Erro ao desativar coprodução"));
    }
  },
  mounted() {
    this.$store
      .dispatch("product/get", { limit: 500 })
      .then()
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    ...mapState("product", ["products", "product"]),
    breadcrumbs() {
      return [
        {
          link: "tools",
          title: "Ferramentas"
        },
        {
          title: "Coproduções"
        }
      ];
    }
  }
};
</script>
